var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBags = function SvgBags(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 7.5V9h4V7.5c0-1.103-.897-2-2-2s-2 .897-2 2m-1.5 3h-2V17A1.5 1.5 0 0 0 8 18.5h8a1.5 1.5 0 0 0 1.5-1.5v-6.5h-2v1.75c0 .416-.334.75-.75.75a.75.75 0 0 1-.75-.75V10.5h-4v1.75c0 .416-.334.75-.75.75a.75.75 0 0 1-.75-.75zm0-1.5V7.5C8.5 5.566 10.066 4 12 4s3.5 1.566 3.5 3.5V9h2a1.5 1.5 0 0 1 1.5 1.5V17a3 3 0 0 1-3 3H8a3 3 0 0 1-3-3v-6.5A1.5 1.5 0 0 1 6.5 9z"
  })));
};
export default SvgBags;